module.exports = __webpack_public_path__ + "img/discounts-active.18fac0c.svg";